import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import serverVars from 'server-vars';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import PdpRespRecentlyViewedItemsCarousel from './PdpRespRecentlyViewedItemsCarousel';
import PdpSharedRecentlyViewedItemsSwiper from '../PdpSharedRecentlyViewedItemsSwiper/PdpSharedRecentlyViewedItemsSwiper';
import { hasRecentlyViewedItems, getRecentlyViewedItems } from '../../utils/recentHistory';
import { recentlyViewed } from '../pdpMessages';
import styles from './PdpRespRecentlyViewedItems.scss';

const PdpRespRecentlyViewedItems = ({ itemId, isClient }) => {
    if (!isClient || !hasRecentlyViewedItems({ itemId })) {
        return null;
    }

    return (
        <Fragment>
            <BarHeader title={recentlyViewed} />
            {serverVars.get('settings.isTablet') ? (
                <PdpSharedRecentlyViewedItemsSwiper
                    items={getRecentlyViewedItems({ itemId })}
                    itemsPerPage={4}
                    classNames={{
                        wrapper: styles.wrapper,
                        item: styles.item,
                        placeholder: styles.placeholder,
                        itemImage: styles.itemImage,
                    }}
                />
            ) : (
                <PdpRespRecentlyViewedItemsCarousel
                    items={getRecentlyViewedItems({ itemId })}
                    itemsPerPage={6}
                    classNames={{
                        placeholder: styles.placeholder,
                        itemLink: styles.itemLink,
                        itemImage: styles.itemImage,
                    }}
                />
            )}
        </Fragment>
    );
};

PdpRespRecentlyViewedItems.propTypes = {
    itemId: PropTypes.string.isRequired,
    isClient: PropTypes.bool.isRequired,
};

export default PdpRespRecentlyViewedItems;
